import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAuthEvents } from "@/api/hooks/admin";
import { EmptyState } from "@/components/EmptyState";
import { ErrorNotice } from "@/components/ErrorNotice";
import { PageHeader } from "@/components/PageHeader";
import { PageLoading } from "@/components/Spinner";
import { Table, TBody, TD, TH, THead, TR } from "@/components/ui/table";
import { formatDateTime } from "@/lib/dates";
import { usePageCrumbs } from "@/app/layouts/shellContext";

export function AuthEventsPage() {
  const { t, i18n } = useTranslation();
  usePageCrumbs([{ label: t("admin.nav.users"), to: "/admin/users" }, { label: t("admin.events.title") }]);
  const { id = "" } = useParams();
  const events = useAuthEvents(id);
  const label = (type: string) => (i18n.exists(`admin.events.type.${type}`) ? t(`admin.events.type.${type}`) : type);
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t("admin.events.title")} description={t("admin.events.intro")} />
      {events.isPending ? <PageLoading /> : null}
      {events.isError ? <ErrorNotice error={events.error} /> : null}
      {events.data && events.data.length === 0 ? <EmptyState title={t("admin.events.empty")} /> : null}
      {events.data && events.data.length > 0 ? (
        <Table>
          <THead>
            <TR>
              <TH>{t("admin.events.colWhen")}</TH>
              <TH>{t("admin.events.colEvent")}</TH>
              <TH>{t("admin.events.colIp")}</TH>
              <TH>{t("admin.events.colBrowser")}</TH>
            </TR>
          </THead>
          <TBody>
            {events.data.map((e) => (
              <TR key={e.id}>
                <TD className="whitespace-nowrap">
                  <time dateTime={e.created_at}>{formatDateTime(e.created_at)}</time>
                </TD>
                <TD>{label(e.type)}</TD>
                <TD className="font-mono text-sm">{e.ip ?? "—"}</TD>
                <TD className="max-w-md break-words text-sm text-fg-muted">{e.user_agent ?? "—"}</TD>
              </TR>
            ))}
          </TBody>
        </Table>
      ) : null}
    </div>
  );
}
